import React from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

type Avatar8Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar8 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar8Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar8" clipPath="url(#clip0_2286_5447)">
        <Path
          id="background"
          d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
          fill={c.background}
        />
        <Path
          id="skin"
          d="M204.595 178.998c.358.191.725.359 1.107.494 7.247 2.596 16.629-5.129 20.969-17.234 4.332-12.113 1.975-24.035-5.272-26.624-4.691-1.68-8.251-1.266-11.11.574-.605-37.948-9.27-63.45-72.456-63.45-36.499 0-40.92 43.882-39.263 80.278 0 13.427-1.776 13.053.048 24.393 13.053 33.855 10.385 47.975 36.316 47.45a82.812 82.812 0 0 0 4.141-.183c1.179 13.674 8.171 54.21 6.722 56.91-1.537 2.883-6.515 11.875-10.377 21.169 5.391.581 10.862.884 16.405.884 27.293 0 52.897-7.208 75.029-19.807-10.098-12.049-24.059-32.039-26.034-52.299-.55-5.607 2.716-34.166 3.767-52.563l.008.008Z"
          fill={c.skin}
        />
        <Path
          id="Vector"
          d="M183.92 123.426s-15.299-5.352-23.876-5.185c-10.074.199-17.457 3.592-19.352.398-.605-1.019-3.815-9.031 18.277-8.418 21.59.606 20.786 6.085 24.951 13.197v.008Z"
          fill="#000"
        />
        <Path
          id="Vector_2"
          d="M173.464 130.418c-1.569-1.187-3.64-2.206-5.758-2.923-2.589-.892-5.344-1.162-8.06-.876-6.036.988-10.847 5.041-13.746 9.446 3.863-2.318 7.725-3.855 11.692-4.373a5.927 5.927 0 0 0-.765 2.907c0 3.496 3.05 6.34 6.817 6.34 3.767 0 6.809-2.836 6.809-6.34 0-.318-.032-.629-.079-.932a33.527 33.527 0 0 1 3.384 1.697c2.939 1.29 5.91-.534 8.323-2.031-2.557.263-6.483-1.601-8.609-2.907l-.008-.008Z"
          fill="#000"
        />
        <Path
          id="Vector_3"
          d="M119.938 115.884c13.921 19.719-8.848 38.107-5.105 42.894 2.612 3.345 20.467-1.601 18.412 5.694-2.054 3.186-22.394 2.772-23.016-5.766-.692-3.727 13.659-27.579 6.372-39.334 2.556.096 3.488-2.756 3.337-3.488Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_4"
          d="M120.527 118.472c.605-1.019 3.815-9.031-18.278-8.418-1.56.04-2.986.12-4.324.207a153.763 153.763 0 0 0-.86 8.052c1.465-.175 2.867-.271 4.117-.247 10.075.199 17.457 3.592 19.353.398l-.008.008Z"
          fill="#000"
        />
        <Path
          id="hair"
          d="M249.384 183.394c-5.654-12.869-3.345-38.848-3.345-38.848s-.486-67.869-27.101-82.284c-22.451-12.16-36.3-13.1-42.552-12.583-3.241-1.617-14.327-6.594-27.221-6.164-15.37.51-47.656 17.935-57.388 33.305-9.732 15.37-1.028 28.185-10.25 45.092-9.222 16.908-25.11 21.519-25.62 46.12-.51 24.593 12.296 32.796 9.732 51.24-1.991 14.311-18.15 23.072-25.302 35.607 24.816 26.839 59.197 44.694 97.726 48.166 3.313-8.33 6.467-19.026 7.749-21.423 1.442-2.708-5.543-43.236-6.721-56.91a94.238 94.238 0 0 1-4.141.183c-25.931.525-23.263-13.595-36.316-47.45-1.824-11.34-.048-10.974-.048-24.393-1.665-36.396 2.763-80.277 39.262-80.277 5.997 0 11.5.23 16.558.685 4.539 3.52 10.265 9.118 13.379 16.636 5.67 13.682.342 14.941 10.552 23.558 10.21 8.609 15.952 7.765 17.115 13.825 1.171 6.061-1.274 20.627 4.356 22.753.534.199.996.343 1.434.47 4.125-11.022 8.856-19.089 20.165-15.044 7.247 2.597 9.604 14.511 5.272 26.624-4.333 12.113-13.722 19.83-20.969 17.234-1.354-.486-.104.581-1.107-.494-1.482 10.521-3.831 42.002-3.831 50.978 0 10.671 3.727 22.171 8.434 30.016 3.416 5.686 12.185 18.014 16.748 24.37a152.546 152.546 0 0 0 48.134-42.496c-1.385-10.552-19.273-46.104-24.704-58.472v-.024Z"
          fill={c.hair}
        />
        <Path
          id="Vector_5"
          d="M109.314 125.927c-.685.031-11.333 2.628-12.44 3.552-1.107.923-.836 1.712-.191 2.588.446.613 6.475-.932 9.636-1.712a5.317 5.317 0 0 0-.318 1.783c0 3.114 2.715 5.647 6.068 5.647 3.154 0 5.742-2.238 6.037-5.097.884.43 1.513.78 1.68.916a1.195 1.195 0 0 0 1.689-.175c.414-.518-4.006-7.893-12.161-7.502Z"
          fill="#000"
        />
        <Path
          id="Vector_6"
          d="M179.046 208.855c-12.862 10.919-26.767 14.821-39.207 15.785-.446.103-.716.159-.748.159 1.131 7.654 2.747 17.505 3.193 23.94 7.717-1.593 20.914-6.857 32-18.93 13.276-14.463 18.213-28.846 20.021-38.427-4.348 6.587-9.477 12.567-15.259 17.481v-.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_7"
          d="M156.118 180.209c-.94.812-15.482 16.485-30.112 15.944-12.464-.454-15.012-13.515-15.307-14.128 0 0 4.022-4.357 7.853-4.213 3.83.143 6.506 2.023 6.506 2.023s4.93-2.947 9-2.796c4.069.152 7.693 2.262 11.5 2.899 3.854.645 10.56.271 10.56.271Zm-5.264 2.19c.063-.095 0 0-.12.04-4.659 1.664-12.686 1.051-25.214.589-6.451-.239-10.783 1.306-14.319.136 3.074 3.432 7.271 6.442 13.714 6.681 12.559.462 22.259-1.871 25.939-7.446Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_2286_5447">
          <Rect width={303.667} height={303.667} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
